import { ShaderMaterial, Vector3, Vector4 } from 'three';
const wind = {
    vertex: `
    // attribute vec3 position;
    // attribute vec3 normal;
    // attribute vec2 uv;
    //
    // uniform mat4 modelViewMatrix;
    // uniform mat4 projectionMatrix;
    
    varying vec2 vUv;
    
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
    fragment: `
    precision highp float;

    uniform float uProgress;
    uniform sampler2D uTexture;
    uniform vec4 uResolution;
    uniform vec3 uColor;
    
    varying vec2 vUv;
    
    float size = 0.2;

    float rand (vec2 co) {
      return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);
    }

    void main()	{
      vec2 newUV = (vUv - vec2(0.5))*uResolution.zw + vec2(0.5);

      float r = rand(vec2(0, newUV.y));
      float m = smoothstep(0.0, -size, newUV.x*(1.0-size) + size*r - ((uProgress) * (1.0 + size)));

      vec4 t1 = vec4(uColor, 1.);
      vec4 t2 = texture2D(uTexture, newUV);
      gl_FragColor = mix(t1, t2, m);
      
      #include <colorspace_fragment>
    }
  `,
};

class Effect {
    static init() {
        if (!Effect.instance) {
            Effect.instance = new Effect();
        }
        return Effect.instance;
    }

    constructor() {
    }

    getMaterial() {
        const shader = wind;

        const options = {
            extensions: {
                derivatives: '#extension GL_OES_standard_derivatives : enable',
            },
            uniforms: {
                uProgress: {type: 'f', value: 0},
                uTexture: {type: 'f', value: undefined},
                uColor: {type: 'v3', value: new Vector3()},
                uResolution: {type: 'v4', value: new Vector4()},
            },
            vertexShader: wind.vertex,
            fragmentShader: wind.fragment,
        }

        return new ShaderMaterial(options);
    }
}

export default Effect;
